"use strict";

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuPrincipal = void 0;

var _react = _interopRequireDefault(require("react"));

var _useHeaderMenu = require("../useHeaderMenu");

var _UiComponents = require("./UiComponents");

var _Brand = require("./Brand");

var _MainLinks = require("./MainLinks");

var _Login = require("./Login");

var _App = require("./App");

var _core = require("@emotion/core");

var MenuPrincipal = function MenuPrincipal() {
  var _ref = (0, _useHeaderMenu.useHeaderMenu)(),
      _ref2 = _slicedToArray(_ref, 1),
      _ref2$ = _ref2[0],
      active = _ref2$.active,
      isOpen = _ref2$.isOpen,
      currentConfig = _ref2$.currentConfig,
      showLogin = _ref2$.showLogin;

  var bgColor = currentConfig.bgColor;
  return (0, _core.jsx)(_UiComponents.Container.Menu, {
    bgColor: isOpen ? null : bgColor,
    isOpen: isOpen,
    active: !!active
  }, (0, _core.jsx)(_UiComponents.Container.Wrapper, {
    maxWidth: "lg"
  }, (0, _core.jsx)(_Brand.Brand, null), (0, _core.jsx)(_UiComponents.Container.InnerMenu, {
    isOpen: isOpen,
    active: !!active
  }, (0, _core.jsx)(_MainLinks.MainLinks, null), showLogin && (0, _core.jsx)(_Login.Login, null), (0, _core.jsx)(_App.App, null))));
};

exports.MenuPrincipal = MenuPrincipal;
MenuPrincipal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MenuPrincipal"
};